// extracted by mini-css-extract-plugin
export var headingClamp = "RacesByDaySkeleton-module--headingClamp--81985";
export var icon = "RacesByDaySkeleton-module--icon--6654b";
export var title = "RacesByDaySkeleton-module--title--97ff5";